import React, { useState } from "react";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { smartCoonectEmployeePostApi } from "../../../text/apidata";
import { getLoaderAction } from "../../../Redux/Loader";
import "../SheetUpload/SheetBulkUploadPopup.scss";



const allAccessOptions = [
  { value: "My Profile", label: "My Profile" },
  { value: "Ticketing", label: "Ticketing" },
  { value: "P2P", label: "Site Request" },
  { value: "Hiring", label: "Hiring" },
  { value: "Business Development", label: "Business Development" },
];

const recordTypeOptions = [
  { value: "0", label: "UDS Billable" },
  { value: "1", label: "UDS Non Billable" },
  { value: "2", label: "Denave Billable" },
  { value: "3", label: "Denave Non Billable" },
  { value: "4", label: "Athena Billable" },
  { value: "5", label: "Athena Non Billable" },
  { value: "6", label: "Avon Billable" },
  { value: "7", label: "Avon Non Billable" },
  { value: "8", label: "Fusion Food Billable" },
  { value: "9", label: "Fusion Food Non Billable" },
  { value: "10", label: "Global Billable" },
  { value: "11", label: "Global Non Billable" },
  { value: "12", label: "Matrix Billable" },
  { value: "13", label: "Matrix Non Billable" },
  { value: "14", label: "WHC Billable" },
  { value: "15", label: "WHC Non Billable" },
];

const statusOptions = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const SmartConnectEditPopup = ({ employeeData, setEditPopup, refreshList }) => {
  const userSessionData = useSelector((state) => state.users.UserData);

  const [formData, setFormData] = useState({
    employee_name: employeeData?.employee_name || "",
    phone_number: employeeData?.phone_number || employeeData?.mobile_number || "",
    email: employeeData?.email || "",
    department: employeeData?.department || "",
    role: employeeData?.role || "",
    record_type:
      recordTypeOptions.find(
        (opt) => opt.value === String(employeeData?.record_type)
      ) || recordTypeOptions[0],
    access: (Array.isArray(employeeData?.access) ? employeeData.access : [])
      .map((val) => allAccessOptions.find((opt) => opt.value === val))
      .filter(Boolean),
    is_active:
      statusOptions.find(
        (opt) => opt.value === Boolean(employeeData?.is_active)
      ) || statusOptions[0],
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    if (name === "phone_number") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }
    setFormData((prev) => ({ ...prev, [name]: updatedValue }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const isBillableType =
    formData.record_type?.value === "0" || formData.record_type?.value === "2" || formData.record_type?.value === "4" || formData.record_type?.value === "6" || formData.record_type?.value === "8" || formData.record_type?.value === "10" || formData.record_type?.value === "12" || formData.record_type?.value === "14";

  const accessOptions = [
    { value: "My Profile", label: "My Profile" },
    { value: "Ticketing", label: "Ticketing" },
    { value: "P2P", label: "Site Request" },
    ...(isBillableType ? [{ value: "Hiring", label: "Hiring" }] : []),
    { value: "Business Development", label: "Business Development" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.employee_name || !formData.employee_name.trim()) {
      newErrors.employee_name = "Employee Name is required";
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!formData.phone_number || !formData.phone_number.trim()) {
      newErrors.phone_number = "Phone Number is required";
    } else if (!phoneRegex.test(formData.phone_number.trim())) {
      newErrors.phone_number = "Phone Number must be a valid 10-digit number";
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (formData.email && formData.email.trim() && !emailRegex.test(formData.email.trim())) {
      newErrors.email = "Please enter a valid Email address";
    }

    if (!formData.record_type) {
      newErrors.record_type = "Type is required";
    }

    if (!formData.access || formData.access.length === 0) {
      newErrors.access = "Access is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    try {
      getLoaderAction(true);
      const token = userSessionData?.session?.token;

      const payload = {
        employee_name: formData.employee_name,
        phone_number: formData.phone_number,
        email: formData.email,
        department: formData.department,
        role: formData.role,
        record_type: formData.record_type?.value,
        access: formData.access?.map((opt) => opt.value),
        is_active: formData.is_active?.value,
      };

      const response = await axios({
        method: "put",
        url: `${smartCoonectEmployeePostApi}${employeeData.id}/`,
        data: payload,
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      getLoaderAction(false);
      toast.success(
        response?.data?.status?.message || "Employee updated successfully"
      );
      setEditPopup(false);
      refreshList();
    } catch (error) {
      getLoaderAction(false);
      toast.error(
        error?.response?.data?.status?.message ||
        error?.response?.data?.message ||
        "Failed to update employee"
      );
    }
  };

  return (
    <div className="overlay">
      <div className="popupContainers" style={{ maxWidth: "650px", width: "100%" }}>
        {/* Header */}
        <div className="popupHeader">
          <div />
          <span className="TitleHeader">Edit Employee</span>
          <button
            className="closeButton"
            type="button"
            onClick={() => setEditPopup(false)}
          >
            ×
          </button>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit} noValidate>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "15px",
            }}
          >
            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Employee Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="employee_name"
                value={formData.employee_name}
                onChange={handleChange}
              />
              {errors.employee_name && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "3px", display: "block" }}>
                  {errors.employee_name}
                </span>
              )}
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Phone Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
              />
              {errors.phone_number && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "3px", display: "block" }}>
                  {errors.phone_number}
                </span>
              )}
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Email
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "3px", display: "block" }}>
                  {errors.email}
                </span>
              )}
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Role
              </label>
              <input
                type="text"
                className="form-control"
                name="role"
                value={formData.role}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Department
              </label>
              <input
                type="text"
                className="form-control"
                name="department"
                value={formData.department}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Type <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                options={recordTypeOptions}
                value={formData.record_type}
                onChange={(val) => {
                  setFormData((prev) => {
                    const isBillable = val?.value === "0" || val?.value === "2";
                    const updatedAccess = isBillable
                      ? prev.access
                      : (prev.access || []).filter((opt) => opt.value !== "Hiring");
                    return {
                      ...prev,
                      record_type: val,
                      access: updatedAccess,
                    };
                  });
                  if (errors.record_type) setErrors((prev) => ({ ...prev, record_type: "" }));
                }}
              />
              {errors.record_type && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "3px", display: "block" }}>
                  {errors.record_type}
                </span>
              )}
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Access <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                isMulti
                options={accessOptions}
                value={formData.access}
                onChange={(val) => {
                  setFormData((prev) => ({ ...prev, access: val }));
                  if (errors.access) setErrors((prev) => ({ ...prev, access: "" }));
                }}
                placeholder="Select Access"
              />
              {errors.access && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "3px", display: "block" }}>
                  {errors.access}
                </span>
              )}
            </div>

            <div>
              <label
                className="form-label"
                style={{ fontWeight: "500", marginBottom: "5px" }}
              >
                Status
              </label>
              <Select
                options={statusOptions}
                value={formData.is_active}
                onChange={(val) =>
                  setFormData((prev) => ({ ...prev, is_active: val }))
                }
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={() => setEditPopup(false)}
              style={{
                background: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                padding: "8px 22px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                background: "linear-gradient(170deg, #ef4d39, #f79c37)",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                padding: "8px 24px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SmartConnectEditPopup;
